import type { ApiV1DashboardSummaryGet200ResponseSummaryRecentActivitiesItem } from './apiV1DashboardSummaryGet200ResponseSummaryRecentActivitiesItem';

export type ApiV1DashboardSummaryGet200ResponseSummary = {
  activeSubscriptions?: number;
  recentActivities?: ApiV1DashboardSummaryGet200ResponseSummaryRecentActivitiesItem[];
  totalOrders?: number;
  totalRevenue?: number;
};
